module.exports = __WEBPACK_EXTERNAL_MODULE_11__;


//////////////////
// WEBPACK FOOTER
// external "@ba/ba-graphics/dist/icons-js/ba-graphics-icons-commons"
// module id = 11
// module chunks = 0 1 2 3